import React, { useState } from "react";
import { useReportingTemplateStore } from "../../../../config/stores";
import { searchTable } from "../../../../config/constants";
import TableButtonActions from "../../../common/TableButtonActions";
import AntdTable from "../../../common/AntdTable";
import TableTitle from "../../../common/TableTitle";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import advanceAccountabilityFormThunks from "../../../../config/thunks/finance/advanceAccountabilityForm/advanceAccountabilityForm.thunks";
import RecordStatus from "../../../common/RecordStatus";

const ReportingTemplatesTable = ({
  reportingTemplates = [],
  canEdit = false,
  refreshTable = () => {},
  viewCustomDetails = null,
}) => {
  const [filterTable, setFilterTableNull] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch();

  const reportingTemplatesStore = useReportingTemplateStore();

  const search = (value) => {
    const filterTable = searchTable(reportingTemplates, value);
    setFilterTableNull(filterTable);
  };

  const confirmDelete = () => {
    reportingTemplatesStore.deleteTimeSheet(deleteId);
    setDeleteId(null);
  };
  const viewDetails = (id, record) => {
    if (viewCustomDetails) {
      viewCustomDetails(record.payment_voucher_id);
    } else {
      reportingTemplatesStore.setViewActivityReport(true);
      console.log({ record });
      dispatch(
        advanceAccountabilityFormThunks.getAdvanceAccountabilityFormDetails(
          record?.payment_voucher_id
        )
      );
    }
  };

  const deleteRecord = (id) => setDeleteId(id);

  const updateRecord = (record) => {
    reportingTemplatesStore.setAddingTimeSheet(false, true, record);
  };

  const columns = [
    {
      title: "Activity",
      render: (record) => {
        return (
          <div>
            <span className="d-md-none">Activity:</span>
            {record.activityConceptNote?.activity?.activity} <br />
            <div className="d-md-none">
              Project : {record.project?.name} <br />
              Concept Note: {record.activityConceptNote?.title} <br />
              Date: {dayjs(`${record.created_at}`).format("DD-MM-YYYY")} <br />
              Actions:
              <TableButtonActions
                record={record}
                confirmDelete={confirmDelete}
                deleteLoading={reportingTemplatesStore.deletingTimeSheet}
                viewDetails={viewDetails}
                updateRecord={updateRecord}
                deleteId={deleteId}
                deleteRecord={deleteRecord}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Payment Voucher",
      dataIndex: "payment_voucher_id",
      key: "payment_voucher_id",
      responsive: ["md"],
    },
    {
      title: "Date",
      dataIndex: "created_at",
      responsive: ["md"],
      width: 100,
      render: (created_at) => dayjs(`${created_at}`).format("DD-MM-YYYY"),
    },
    {
      title: "Concept Note",
      dataIndex: "activityConceptNote",
      key: "activityConceptNote",
      responsive: ["md"],
      render: (activityConceptNote) => activityConceptNote?.title,
    },
    {
      title: "Thematic Area",
      dataIndex: "activityConceptNote",
      key: "activityConceptNote",
      responsive: ["md"],
      render: (activityConceptNote) =>
        activityConceptNote?.thematicArea?.thematic_area,
    },
    {
      title: "Project",
      key: "project",
      dataIndex: "project",
      responsive: ["md"],
      render: (project) => project?.name,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <RecordStatus status={status} />,
    },
    {
      title: "Actions",
      key: "actions",
      responsive: ["md"],
      render: (record) => {
        return (
          <TableButtonActions
            record={record}
            confirmDelete={confirmDelete}
            deleteLoading={reportingTemplatesStore.deletingTimeSheet}
            viewDetails={viewDetails}
            updateRecord={canEdit && updateRecord}
            deleteId={deleteId}
            deleteRecord={canEdit && deleteRecord}
          />
        );
      },
    },
  ];

  const openAddModal = () => {
    reportingTemplatesStore.setAddingTimeSheet(true, true, {});
  };

  return (
    <div>
      <AntdTable
        loading={
          reportingTemplatesStore.gettingReportingTemplates ||
          reportingTemplatesStore.gettingProjectReportingTemplates
        }
        title={() => (
          <TableTitle
            setFilterTableNull={setFilterTableNull}
            openAddModal={canEdit && openAddModal}
            refreshTable={refreshTable}
            search={search}
            exportRecords={null}
          />
        )}
        pageSize={20}
        data={filterTable === null ? reportingTemplates || [] : filterTable}
        columns={columns}
      />
    </div>
  );
};

export default ReportingTemplatesTable;
